var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.response)?_c('div',[(_vm.response.notes.length > 0)?_c('div',{staticClass:"tc-title tc-title--s mb-5"},[_vm._v(" "+_vm._s(_vm.$t('ticket-details-conversation.messages'))+" ")]):_vm._e(),_c('InfraReportingConversation',{attrs:{"items":_vm.response.notes,"label-customer":_vm.$t('ticket-details-conversation.customer')}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }